import React from 'react';

const ContactButtons = () => {
  return (
    <div 
      className="contact-buttons" 
      style={{
        position: 'fixed', 
        bottom: '20px', 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'space-between', 
        padding: '0 20px', 
        zIndex: 1000,
        pointerEvents: 'none', // Allow clicks to pass through this container
      }}
    >
      
      <a 
        href="tel:+918793220265" 
        className="call-button" 
        style={{
          backgroundColor: '#24ABE2', 
        
          borderRadius: '50%',
          border : '1px solid white',
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001, // Ensure button is above the container
          pointerEvents: 'auto', // Allow clicks on this specific button
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#24ABE2')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#24ABE2')}
      >
        <img src="./images/telephon.png" alt="Call" style={{ width: '30px', height: '30px' }} />
      </a>

      <a 
        href="https://wa.me/+918793220265?text=Hello%20Anjali%20Enterprises%20Team,%20I%20am%20interested%20in%20your%20services%20for%20All%20types%20of%20aluminium%20glass%20office%20partition,%20toughened%20glass%20work,%20door%20partition,%20ACP%20cladding%20panel%20installation,%20aluminium%20glass%20windows,%20soundproof%20glass%20windows,%20aluminium%20mosquito%20net,%20bird%20net%20installation,%20invisible%20grill%20installation,%20MS%20fabrication%20door,%20MS%20fabrication%20shade,%20MS%20fabrication%20grill,%20MS%20fabrication%20slide%20door,%20MS%20fabrication%20industrial%20shade,%20industrial%20fabrication%20work,%20furniture%20work,%20home%20renovation,%20painting%20work,%20and%20foil%20ceiling%20work.%20Please%20send%20more%20details%20or%20call%20me.%20Thank%20you!"

        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          backgroundColor: '#25D366', 
          borderRadius: '50%', 
          padding: '15px', 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          transition: 'background-color 0.3s',
          zIndex: 1001,
          pointerEvents: 'auto', 
        }}
        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#1DAE3E')}
        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#25D366')}
      >
        <img src="./images/whatsapp.png" alt="WhatsApp" style={{ width: '30px', height: '30px' }} />
      </a>

    </div>
  );
};

export default ContactButtons;

